import React from "react"

export const UndoIcon = ({ color = "#034055", size = 1 }) => {
  return (
    <svg
      width={size * 26}
      height={size * 24}
      viewBox="0 0 26 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M.99 23.49v-23h23v23z" />
        <path
          d="M3.865 13.427a9.104 9.104 0 1 0 9.104-9.104"
          stroke={color}
          strokeWidth="3"
        />
        <path fill={color} d="M13.97.01v8.72L8.13 4.37z" />
      </g>
    </svg>
  )
}
